export const PostsTableInitializer = 'Posts';
export const PostsTableComparator = 'createdAt';
